import React, { useRef } from 'react'
import t from 'prop-types'

import PillarChapterWrapper from '../PillarChapterWrapper'

const PillarContent = ({ content, setChapterRef, currentChapter }) => {
  const chapterGrouped = []
  let whichChapter = 0
  for (let block of content) {
    if ('post_Acfpillarpage_Content_Chapter' === block.fieldGroupName) {
      whichChapter = block.index
    }

    chapterGrouped[whichChapter] = chapterGrouped[whichChapter] || []

    chapterGrouped[whichChapter].push(block)
  }

  return (
    <div className="pillar-content">
      {chapterGrouped.map((groupedContent, index) => {
        return (
          <PillarChapterWrapper
            groupedContent={groupedContent}
            setChapterRef={setChapterRef}
            index={index}
          />
        )
      })}
    </div>
  )
}

PillarContent.propTypes = {
  content: t.array,
  setChapterRef: t.bool,
}

PillarContent.defaultProps = {
  content: [],
  setChapterRef: false,
}

export default PillarContent
